import { useState } from 'react';
// @mui
import { CircularProgress } from '@mui/material';
// ui
import { Button } from 'src/@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from 'src/@/components/ui/dialog';
import { Input } from 'src/@/components/ui/input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from 'src/@/components/ui/table';
// components
import Iconify from 'src/components/Iconify';

// ----------------------------------------------------------------------

export default function ModalCategorias({
    open,
    onClose,
    categories = [],
    categoryActions, // { create, update, delete }
}) {
    const [newCategory, setNewCategory] = useState('');
    const [editingId, setEditingId] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [loading, setLoading] = useState(false);

    const handleAdd = async () => {
        if (!newCategory.trim()) return;
        setLoading(true);
        try {
            await categoryActions.create(newCategory.trim());
            setNewCategory('');
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id) => {
        setLoading(true);
        try {
            await categoryActions.delete(id);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleStartEdit = (cat) => {
        setEditingId(cat._id || cat.id);
        setEditValue(cat.name);
    };

    const handleSaveEdit = async () => {
        if (!editValue.trim() || !editingId) return;
        setLoading(true);
        try {
            await categoryActions.update(editingId, editValue.trim());
            setEditingId(null);
            setEditValue('');
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-md bg-white border-gray-100">
                <DialogHeader>
                    <DialogTitle className="text-xl font-bold text-gray-900 flex items-center gap-2">
                        <div className="p-2 bg-violet-100 rounded-lg">
                            <Iconify icon="solar:tag-horizontal-bold-duotone" className="w-5 h-5 text-[#7C3AED]" />
                        </div>
                        Gerenciar Categorias
                    </DialogTitle>
                </DialogHeader>

                <div className="flex flex-col gap-4 py-4">
                    <div className="flex gap-2">
                        <Input
                            placeholder="Nova categoria..."
                            value={newCategory}
                            onChange={(e) => setNewCategory(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && handleAdd()}
                            className="bg-gray-50"
                            disabled={loading}
                        />
                        <Button onClick={handleAdd} disabled={loading} className="bg-[#7C3AED] hover:bg-[#6d28d9] text-white">
                            {loading ? <CircularProgress size={20} className="text-white" /> : <Iconify icon="solar:add-circle-bold" className="w-5 h-5" />}
                        </Button>
                    </div>

                    <div className="rounded-lg border border-gray-100 overflow-hidden max-h-[300px] overflow-y-auto">
                        <Table>
                            <TableHeader className="bg-gray-50">
                                <TableRow>
                                    <TableHead>Nome</TableHead>
                                    <TableHead className="text-right">Ações</TableHead>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {categories.length === 0 && (
                                    <TableRow>
                                        <TableCell colSpan={2} className="text-center text-gray-500 py-8">
                                            Nenhuma categoria cadastrada
                                        </TableCell>
                                    </TableRow>
                                )}
                                {categories.map((cat) => (
                                    <TableRow key={cat._id || cat.id}>
                                        <TableCell>
                                            {editingId === (cat._id || cat.id) ? (
                                                <div className="flex gap-2">
                                                    <Input value={editValue} onChange={(e) => setEditValue(e.target.value)} className="h-8" />
                                                    <Button size="sm" onClick={handleSaveEdit} className="h-8 w-8 p-0 bg-green-600 hover:bg-green-700">
                                                        <Iconify icon="solar:check-bold" className="w-4 h-4" />
                                                    </Button>
                                                </div>
                                            ) : (
                                                <span className="font-medium">{cat.name}</span>
                                            )}
                                        </TableCell>
                                        <TableCell className="text-right">
                                            <div className="flex justify-end gap-1">
                                                <Button
                                                    variant="ghost"
                                                    size="icon"
                                                    className="h-8 w-8 text-blue-600 hover:bg-blue-50"
                                                    onClick={() => handleStartEdit(cat)}
                                                >
                                                    <Iconify icon="solar:pen-bold" className="w-4 h-4" />
                                                </Button>
                                                <Button
                                                    variant="ghost"
                                                    size="icon"
                                                    className="h-8 w-8 text-red-600 hover:bg-red-50"
                                                    onClick={() => handleDelete(cat._id || cat.id)}
                                                >
                                                    <Iconify icon="solar:trash-bin-trash-bold" className="w-4 h-4" />
                                                </Button>
                                            </div>
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </div>
                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={onClose}>
                        Concluir
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}